import { Subject } from 'rxjs';
import { UserLocation } from './location';

export type AutocompleteSelectableOption = AutocompleteStandardOption | SearchAutoSuggestOption;

export type AutocompleteOption = AutocompleteSelectableOption | AutocompleteJSXOption;

export type AutocompleteBaseOption = {
  id: string;
  type: AutocompleteOptionType;
};

export enum AutoSuggestSearchOptionType {
  EQUIPMENTCLASS,
  CATEGORIES,
}

export type AutocompleteStandardOption = AutocompleteBaseOption & {
  type: AutocompleteOptionType.STANDARD;
  label: string;
  ignoreDefaultSelect?: boolean;
};

export type SearchAutoSuggestOption = AutocompleteBaseOption & {
  type: AutocompleteOptionType.STANDARD;
  label: string;
  slug: string;
  optionType: AutoSuggestSearchOptionType;
};

export type AutocompleteJSXOption = AutocompleteBaseOption & {
  type: AutocompleteOptionType.JSX;
  element: JSX.Element;
};

export type AutocompleteOptionGroup = {
  id: string;
  groupLabel: string;
  groupItems: AutocompleteOption[];
};

export type AutocompletePopupPosition = 'absolute' | 'relative';

export type AutocompleteHelperTextPosition = 'absolute' | 'relative';

export enum AutocompleteOptionType {
  STANDARD = 'STANDARD',
  JSX = 'JSX',
}

export type UpdateAutocompleteSubjectType = Subject<{
  nextInputValue?: string;
  nextOptions?: Promise<AutocompleteOptionGroup[]>;
}>;

export type LocationHelperText = {
  element: JSX.Element;
  position?: AutocompleteHelperTextPosition;
};

export type LocationHelperTexts = {
  default?: LocationHelperText;
  invalidInput?: LocationHelperText;
};

export type AddressFieldSelectMetadata = { userLocation?: UserLocation };

/*
 * Autocomplete Component Props
 */
export type OnAutocompleteInputChange = (value: string, metadata?: { isActive?: boolean }) => void;

export type AddressSourceType = 'googleAutocomplete' | 'manualEntry';
